<template>
    <div :class="sidebarbg" class="app-sidebar sidebar-shadow" @mouseover="toggleSidebarHover('add','closed-sidebar-open')" @mouseleave="toggleSidebarHover('remove','closed-sidebar-open')">
        <div class="app-header__logo">
            <div class="logo-src"/>
            <div class="header__pane ml-auto">
                <button type="button" class="hamburger close-sidebar-btn hamburger--elastic" v-bind:class="{ 'is-active' : isOpen }" @click="toggleBodyClass('closed-sidebar')">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
            </div>
        </div>
        <div class="app-sidebar-content">
            <VuePerfectScrollbar class="app-sidebar-scroll" v-once>
                <sidebar-menu showOneChild :menu="menu"/>
            </VuePerfectScrollbar>
        </div>

    </div>
</template>

<script>
    import {SidebarMenu} from 'vue-sidebar-menu'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'

    export default {
        components: {
            SidebarMenu,
            VuePerfectScrollbar
        },
        data() {
            return {
                isOpen: false,
                sidebarActive: false,

                menu: [
                    {
                        header: true,
                        title: 'Main Navigation',
                    },
                    {
                        title: 'Dashboards',
                        icon: 'pe-7s-rocket',
                        child: [
                            {
                                href: '/theme/',
                                title: 'Analytics',
                            },
                            {
                                href: '/theme/dashboards/advertisement',
                                title: 'Advertisement',
                            },
                            {
                                href: '/theme/dashboards/management',
                                title: 'Management',
                            },
                            {
                                href: '/theme/dashboards/helpdesk',
                                title: 'Helpdesk',
                            },
                            {
                                href: '/theme/dashboards/monitoring',
                                title: 'Monitoring',
                            },
                            {
                                href: '/theme/dashboards/crypto',
                                title: 'Crypto',
                            },
                            {
                                href: '/theme/dashboards/project-management',
                                title: 'Project Management',
                            },
                            {
                                href: '/theme/dashboards/product',
                                title: 'Product',
                            },
                            {
                                href: '/theme/dashboards/statistics',
                                title: 'Statistics',
                            },
                        ]
                    },
                    {
                        title: 'Pages',
                        icon: 'pe-7s-browser',
                        child: [
                            {
                                href: '/theme/pages/login',
                                title: 'Login',
                            },
                            {
                                href: '/theme/pages/login-boxed',
                                title: 'Login Boxed',
                            },
                            {
                                href: '/theme/pages/register',
                                title: 'Register',
                            },
                            {
                                href: '/theme/pages/register-boxed',
                                title: 'Register Boxed',
                            },
                            {
                                href: '/theme/pages/forgot-password',
                                title: 'Forgot Password',
                            },
                            {
                                href: '/theme/pages/forgot-password-boxed',
                                title: 'Forgot Password Boxed',
                            },
                        ]
                    },
                    {
                        title: 'Applications',
                        icon: 'pe-7s-plugin',
                        child: [
                            {
                                href: '/theme/apps/mailbox',
                                title: 'Mailbox',
                            },
                            {
                                href: '/theme/apps/chat',
                                title: 'Chat',
                            },
                            {
                                title: 'Forums Section',
                                child: [
                                    {
                                        href: '/theme/apps/forums-listing',
                                        title: 'Listing',
                                    },
                                    {
                                        href: '/theme/apps/forums-threads',
                                        title: 'Threads',
                                    },
                                    {
                                        href: '/theme/apps/forums-discussion',
                                        title: 'Discussions',
                                    },
                                ]
                            },
                        ]
                    },
                    {
                        header: true,
                        title: 'UI Components',
                    },
                    {
                        icon: 'pe-7s-diamond',
                        title: 'Elements',
                        child: [
                            {
                                title: 'Buttons',
                                child: [
                                    {
                                        title: 'Standard',
                                        href: '/theme/elements/buttons-standard',
                                    },
                                    {
                                        title: 'Pills',
                                        href: '/theme/elements/buttons-pills',

                                    },
                                    {
                                        title: 'Square',
                                        href: '/theme/elements/buttons-square',

                                    },
                                    {
                                        title: 'Shadow',
                                        href: '/theme/elements/buttons-shadow',

                                    },
                                    {
                                        title: 'With Icons',
                                        href: '/theme/elements/buttons-icons',
                                    },
                                ]
                            },
                            {
                                title: 'Dropdowns',
                                href: '/theme/elements/dropdowns',
                            },
                            {
                                title: 'Icons',
                                href: '/theme/elements/icons',
                            },
                            {
                                title: 'Badges',
                                href: '/theme/elements/badges-labels',
                            },
                            {
                                title: 'Cards',
                                href: '/theme/elements/cards',
                            },
                            {
                                title: 'Loading Indicators',
                                href: '/theme/elements/loaders',
                            },
                            {
                                title: 'List Groups',
                                href: '/theme/elements/list-group',
                            },
                            {
                                title: 'Navigation Menus',
                                href: '/theme/elements/navigation',
                            },
                            {
                                title: 'Timeline',
                                href: '/theme/elements/timelines',
                            },
                            {
                                title: 'Utilities',
                                href: '/theme/elements/utilities',
                            },
                        ],
                    },
                    {
                        icon: 'pe-7s-car',
                        title: 'Components',
                        child: [
                            {
                                title: 'Tabs',
                                href: '/theme/components/tabs',
                            },
                            {
                                title: 'Accordions',
                                href: '/theme/components/accordions',
                            },
                            {
                                title: 'Sweet Alerts',
                                href: '/theme/components/swal-alerts',
                            },
                            {
                                title: 'Modals',
                                href: '/theme/components/modals',
                            },
                            {
                                title: 'Progress Bar',
                                href: '/theme/components/progress-bar',
                            },
                            {
                                title: 'Tooltips & Popovers',
                                href: '/theme/components/tooltips-popovers',
                            },
                            {
                                title: 'Carousel',
                                href: '/theme/components/carousel',
                            },
                            {
                                title: 'Calendar',
                                href: '/theme/components/calendar',
                            },
                            {
                                title: 'Pagination',
                                href: '/theme/components/pagination',
                            },
                            {
                                title: 'Count Up',
                                href: '/theme/components/count-up',
                            },
                            {
                                title: 'Scrollable',
                                href: '/theme/components/scrollable-elements',
                            },
                            {
                                title: 'Maps',
                                href: '/theme/components/maps',
                            },
                            {
                                title: 'Ratings',
                                href: '/theme/components/ratings',
                            },
                            {
                                title: 'Image Crop',
                                href: '/theme/components/image-crop',
                            },
                        ],
                    },
                    {
                        icon: 'pe-7s-display2',
                        title: 'Tables',
                        child: [
                            {
                                title: 'Regular Tables',
                                href: '/theme/tables/regular-tables',
                            },
                            {
                                title: 'Dynamic Tables',
                                href: '/theme/tables/dynamic-tables',
                            },
                        ]
                    },
                    {
                        header: true,
                        title: 'Material Components',
                    },
                    {
                        icon: 'pe-7s-diamond',
                        title: 'Form Controls',
                        child: [
                            {
                                title: 'Autocompletes',
                                href: '/theme/material-components/autocompletes',
                            },
                            {
                                title: 'Combobox',
                                href: '/theme/material-components/combobox',
                            },
                            {
                                title: 'Forms',
                                href: '/theme/material-components/forms',
                            },
                            {
                                title: 'Selects',
                                href: '/theme/material-components/selects',
                            },
                            {
                                title: 'Selection controls',
                                href: '/theme/material-components/selection-controls',
                            },
                            {
                                title: 'Sliders',
                                href: '/theme/material-components/sliders',
                            },
                            {
                                title: 'Textareas',
                                href: '/theme/material-components/textareas',
                            },
                            {
                                title: 'Text fields',
                                href: '/theme/material-components/text-fields',
                            },
                            {
                                title: 'Datepickers',
                                href: '/theme/material-components/datepickers',
                            },
                            {
                                title: 'Timepickers',
                                href: '/theme/material-components/timepickers',
                            },
                        ]
                    },
                    {
                        icon: 'pe-7s-diamond',
                        title: 'Navigation',
                        child: [
                            {
                                title: 'Breadcrumbs',
                                href: '/theme/material-components/breadcrumbs',
                            },
                            {
                                title: 'Menus',
                                href: '/theme/material-components/menus',
                            },
                            {
                                title: 'Navigation drawers',
                                href: '/theme/material-components/navigation-drawers',
                            },
                            {
                                title: 'Toolbars',
                                href: '/theme/material-components/toolbars',
                            },
                        ]
                    },
                    {
                        icon: 'pe-7s-diamond',
                        title: 'Layout',
                        child: [
                            {
                                title: 'Cards',
                                href: '/theme/material-components/cards',
                            },
                            {
                                title: 'Tabs',
                                href: '/theme/material-components/tabs',
                            },
                            {
                                title: 'Subheaders',
                                href: '/theme/material-components/subheaders',
                            },
                            {
                                title: 'Timelines',
                                href: '/theme/material-components/timelines',
                            },
                            {
                                title: 'Groups',
                                href: '/theme/material-components/groups',
                            },
                        ]
                    },
                    {
                        icon: 'pe-7s-diamond',
                        title: 'Buttons & Indicators',
                        child: [
                            {
                                title: 'Buttons',
                                href: '/theme/material-components/buttons',
                            },
                            {
                                title: 'Hover',
                                href: '/theme/material-components/hover',
                            },
                            {
                                title: 'Icons',
                                href: '/theme/material-components/icons',
                            },
                            {
                                title: 'Images',
                                href: '/theme/material-components/images',
                            },
                            {
                                title: 'Lists',
                                href: '/theme/material-components/lists',
                            },
                            {
                                title: 'Progress',
                                href: '/theme/material-components/progress',
                            },
                            {
                                title: 'Paginations',
                                href: '/theme/material-components/paginations',
                            },
                            {
                                title: 'Sparklines',
                                href: '/theme/material-components/sparklines',
                            },
                            {
                                title: 'Steppers',
                                href: '/theme/material-components/steppers',
                            },
                        ]
                    },
                    {
                        icon: 'pe-7s-diamond',
                        title: 'Popups & Modals',
                        child: [
                            {
                                title: 'Bottom Navigation',
                                href: '/theme/material-components/bottom-navigation',
                            },
                            {
                                title: 'Bottom Sheets',
                                href: '/theme/material-components/bottom-sheets',
                            },
                            {
                                title: 'Dialogs',
                                href: '/theme/material-components/dialogs',
                            },
                            {
                                title: 'Sheets',
                                href: '/theme/material-components/sheets',
                            },
                            {
                                title: 'Snackbars',
                                href: '/theme/material-components/snackbars',
                            },
                        ]
                    },
                    {
                        icon: 'pe-7s-diamond',
                        title: 'Components',
                        child: [
                            {
                                title: 'Calendars',
                                href: '/theme/material-components/calendars',
                            },
                            {
                                title: 'Carousels',
                                href: '/theme/material-components/carousels',
                            },
                            {
                                title: 'Alerts',
                                href: '/theme/material-components/alerts',
                            },
                            {
                                title: 'Avatars',
                                href: '/theme/material-components/avatars',
                            },
                            {
                                title: 'Badges',
                                href: '/theme/material-components/badges',
                            },
                            {
                                title: 'Chips',
                                href: '/theme/material-components/chips',
                            },
                            {
                                title: 'Data iterator',
                                href: '/theme/material-components/data-iterator',
                            },
                            {
                                title: 'Data tables',
                                href: '/theme/material-components/data-tables',
                            },
                            {
                                title: 'Dividers',
                                href: '/theme/material-components/dividers',
                            },
                            {
                                title: 'Expansion panels',
                                href: '/theme/material-components/expansion-panels',
                            },
                            {
                                title: 'Footer',
                                href: '/theme/material-components/footer',
                            },
                            {
                                title: 'Parallax',
                                href: '/theme/material-components/parallax',
                            },
                            {
                                title: 'Ratings',
                                href: '/theme/material-components/ratings',
                            },
                            {
                                title: 'Tooltips',
                                href: '/theme/material-components/tooltips',
                            },
                            {
                                title: 'Treeview',
                                href: '/theme/material-components/treeview',
                            },
                            {
                                title: 'Ripples',
                                href: '/theme/material-components/ripples',
                            },
                        ]
                    },
                    {
                        header: true,
                        title: 'Dashboard Boxes',
                    },
                    {
                        icon: 'pe-7s-graph2',
                        title: 'Chart Boxes',
                        child: [
                            {
                                title: 'Variation 1',
                                href: '/theme/widgets/chart-boxes',
                            },
                            {
                                title: 'Variation 2',
                                href: '/theme/widgets/chart-boxes-2',
                            },
                            {
                                title: 'Variation 3',
                                href: '/theme/widgets/chart-boxes-3',
                            },
                        ]
                    },
                    {
                        icon: 'pe-7s-id',
                        title: 'Profile Boxes',
                        href: '/theme/widgets/profile-boxes',
                    },
                    {
                        header: true,
                        title: 'Forms',
                    },
                    {
                        icon: 'pe-7s-light',
                        title: 'Elements',
                        child: [
                            {
                                title: 'Controls',
                                href: '/theme/forms/controls',
                            },
                            {
                                title: 'Layouts',
                                href: '/theme/forms/layouts',
                            },
                            {
                                title: 'Validation',
                                href: '/theme/forms/validation',
                            },
                            {
                                title: 'Wizards',
                                href: '/theme/forms/wizards',
                            },
                            {
                                title: 'Sticky Form Headers',
                                href: '/theme/forms/sticky-headers',
                            },
                        ],
                    },
                    {
                        icon: 'pe-7s-joy',
                        title: 'Widgets',
                        child: [
                            {
                                title: 'Datepicker',
                                href: '/theme/forms/datepicker',
                            },
                            {
                                title: 'Range Slider',
                                href: '/theme/forms/range-slider',
                            },
                            {
                                title: 'Input Selects',
                                href: '/theme/forms/input-selects',
                            },
                            {
                                title: 'Toggle Switch',
                                href: '/theme/forms/toggle-switch',
                            },
                            {
                                title: 'WYSIWYG Editors',
                                href: '/theme/forms/wysiwyg-editors',
                            },
                            {
                                title: 'Input Mask',
                                href: '/theme/forms/input-mask',
                            },
                            {
                                title: 'Clipboard',
                                href: '/theme/forms/clipboard',
                            },
                            {
                                title: 'Textarea Autosize',
                                href: '/theme/forms/textarea-autosize',
                            },
                            {
                                title: 'Color Picker',
                                href: '/theme/forms/colorpicker',
                            },
                            {
                                title: 'Dropzone',
                                href: '/theme/forms/dropzone',
                            },
                        ],
                    },
                    {
                        header: true,
                        title: 'Charts',
                    },
                    {
                        icon: 'pe-7s-graph2',
                        title: 'ChartJS',
                        href: '/theme/charts/chartjs',
                    },
                    {
                        icon: 'pe-7s-graph',
                        title: 'Apex Charts',
                        href: '/theme/charts/apexcharts',
                    },
                    {
                        icon: 'pe-7s-gleam',
                        title: 'Gauges',
                        href: '/theme/charts/gauges',
                    },
                    {
                        icon: 'pe-7s-graph1',
                        title: 'Chart Sparklines',
                        href: '/theme/charts/sparklines',
                    },
                ],
                collapsed: true,

                windowWidth: 0,

            }
        },
        props: {
            sidebarbg: String,

        },
        methods: {

            toggleBodyClass(className) {
                const el = document.body;
                this.isOpen = !this.isOpen;

                if (this.isOpen) {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            },
            toggleSidebarHover(add, className) {
                const el = document.body;
                this.sidebarActive = !this.sidebarActive;

                this.windowWidth = document.documentElement.clientWidth;

                if (this.windowWidth > '992') {
                    if (add === 'add') {
                        el.classList.add(className);
                    } else {
                        el.classList.remove(className);
                    }
                }
            },
            getWindowWidth() {
                const el = document.body;

                this.windowWidth = document.documentElement.clientWidth;

                if (this.windowWidth < '1350') {
                    el.classList.add('closed-sidebar', 'closed-sidebar-md');
                } else {
                    el.classList.remove('closed-sidebar', 'closed-sidebar-md');
                }
            },
        },
        mounted() {
            this.$nextTick(function () {
                window.addEventListener('resize', this.getWindowWidth);

                //Init
                this.getWindowWidth()
            })
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.getWindowWidth);
        }
    }
</script>
